import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets window scroll on every SPA navigation. Disables browser scroll restoration
 * so mobile Safari and others do not restore a stale offset after route changes.
 */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    const scrollAll = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    scrollAll();
    const raf = window.requestAnimationFrame(scrollAll);
    return () => window.cancelAnimationFrame(raf);
  }, [pathname, search]);

  return null;
}
